module.exports = __webpack_public_path__ + "img/error.e28fcab.png";